function parseFilterDate(value) {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  if (typeof value === "string") {
    const dateOnlyMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnlyMatch) {
      const year = Number(dateOnlyMatch[1]);
      const month = Number(dateOnlyMatch[2]) - 1;
      const day = Number(dateOnlyMatch[3]);
      return new Date(year, month, day);
    }
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
}

function toDateString(dateValue) {
  if (!dateValue) return null;
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

function tryCollapseDateRangeToEquals(left, right, fieldName) {
  const extractRange = (first, second) => {
    if (!Array.isArray(first) || !Array.isArray(second) || first.length < 3 || second.length < 3) {
      return null;
    }

    const isStart = first[0] === fieldName && first[1] === ">=";
    const isEnd = second[0] === fieldName && second[1] === "<";
    if (!isStart || !isEnd) {
      return null;
    }

    return { start: first[2], end: second[2] };
  };

  const direct = extractRange(left, right);
  const reversed = direct ? null : extractRange(right, left);
  const range = direct || reversed;

  if (!range) {
    return null;
  }

  const startDate = parseFilterDate(range.start);
  const endDate = parseFilterDate(range.end);
  if (!startDate || !endDate) {
    return null;
  }

  const oneDayMs = 24 * 60 * 60 * 1000;
  if (endDate.getTime() - startDate.getTime() !== oneDayMs) {
    return null;
  }

  return [fieldName, "=", toDateString(startDate)];
}

export function normalizeDateFilter(filter, fieldName) {
  if (!Array.isArray(filter)) {
    return filter;
  }

  if (filter.length === 3 && (filter[1] === "and" || filter[1] === "or")) {
    const left = normalizeDateFilter(filter[0], fieldName);
    const operator = filter[1];
    const right = normalizeDateFilter(filter[2], fieldName);

    if (operator === "and") {
      const collapsed = tryCollapseDateRangeToEquals(left, right, fieldName);
      if (collapsed) {
        return collapsed;
      }
    }

    return [left, operator, right];
  }

  return filter.map((item) => normalizeDateFilter(item, fieldName));
}